import MpkStartPage from './MpkStartPage';

export default MpkStartPage;
